import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { applyTheme, readTheme } from "./theme/ThemeContext";
import { stageInitialWorkerVerification } from "./components/installer/workerEnrollmentLinks";
import { consumeInitialPrivateAccess } from "./lib/privateAccess";

stageInitialWorkerVerification();
consumeInitialPrivateAccess();
applyTheme(readTheme());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
